/**
 * Leads API Slice
 * Handles contact form submissions from public landing page
 */

import { apiSlice } from "../api/apiSlice";

// Lead form data structure
export interface LeadFormData {
  name: string;
  company: string;
  email: string;
  phone: string;
  message: string;
}

// Backend response structure
interface LeadSubmissionResponse {
  success: boolean;
  message: string;
  leadId?: string;
}

export const leadsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    /**
     * Submit lead from contact form
     * Public endpoint - no authentication required
     */
    submitLead: builder.mutation<LeadSubmissionResponse, LeadFormData>({
      query: (formData) => ({
        url: `/api/public/leads`,
        method: "POST",
        body: formData,
      }),
    }),
  }),
});

export const { useSubmitLeadMutation } = leadsApiSlice;
